export default {
  settlement: {
    pay: {
      title: '決済サービス',
      channel: '決済チャネル',
      method: '決済方法',
      rate: '料率',
      serviceFee:'Service Fee',
      total:'合計料率',
      trade: 'トランザクション费用(円)',
      cycle: '清算サイクル',
      tax: '課税',
      select: '選択'
    },
    pci: {
      title: 'PCI DSS準拠状況',
      date:'PCI DSS準拠予定年月',
      yes: '準拠している',
      no: '準拠予定なし',
      plan: '予定',
      tip: 'PCI DSSの準拠証明書をお持ちの場合は「準拠している」、お持ちでない場合は「準拠予定なし」をご選択ください。'
    },
    card: {
      title: 'カード情報保持状況',
      date: '非保持化予定年月',
      yes: '非保持化',
      no: '非保持化予定なし',
      tip1: '今後お客様のカード番号を自社内で取り扱う予定がない場合は「非保持化済」をご選択ください。',
      tip2: 'ご利用のシステム会社がPCIDSS準拠しており、証明書の提示を受けている場合は「非保持化予定なし」をご選択ください。'

    },
    ic:{
      title:'决済端末IC化実施状况',
      date:'决済端末IC化実施予定年',
      yes:'有',
      no:'無',
      plan: '予定'
    },
    goods: {
      title:'決済端末等の注文',
      goods: '対象商品',
      firstCost: '初期設置費用',
      price: '商品価格',
      count: '数量',
      bond: '保証金',
      totalAmount: '合計金額',
      action: '操作'
    },
    questionnaire: {
      title: 'カード情報セキュリティ対策に関するアンケート',
      // 基本信息部分
      section1: {
        title: '(1) 加盟店の基本情報を記入してください。',
        fields: {
          storeName: '1.1. 加盟店名称（会社名）',
          websiteUrl: '1.2. 運営するウェブサイトのURL',
          representativeName: '1.3. 代表者名',
          responderName: '1.4. 回答者名',
          phoneNumber: '1.5. 電話番号',
          email: '1.6. メールアドレス'
        },
        placeholders: {
          storeName: '会社名を入力',
          websiteUrl: 'https://example.com',
          representativeName: '代表者名を入力',
          responderName: '回答者名を入力',
          phoneNumber: '03-1234-5678',
          email: 'email@example.com'
        }
      },
      // 销售方式部分
      section2: {
        title: '(2) 次に、加盟店の販売方式等についてお答えください。',
        fields: {
          acceptCreditCard: {
            label: '2.1. 加盟店はクレジットカード決済を導入していますか？',
             options: {
                online: { label: 'はい', value: true },
                offline: { label: 'いいえ', value: false }
              }
          },
          paymentType: {
            label: '2.2. オンライン決済、オフライン決済',
             options: {
                online: { label: 'オンライン', value: true },
                offline: { label: 'オフライン', value: false }
              }
          },
          salesMethod: {
            label: '2.3. 販売方式はどれですか？',
             options: [
              { label: '店舗販売（対面販売）', value: 'DOORSALE' },
              { label: '電話またはFAX販売', value: 'PHONESALE' },
              { label: 'インターネット販売（自社サイト）', value: 'WEBSALE' },
              { label: 'アプリ販売', value: 'APPSALE' },
              { label: 'その他（自由記入）', value: 'OTHERSALE' }
            ],
          },
          otherSalesMethod: {
            label: 'その他の販売方法',
            placeholder: 'その他の販売方法を入力してください'
          }
        }
      },

      // 系统对策部分
      section3: {
        title: '(3) カード情報管理状況（システム対策）',
        note: '※3～4項で「いいえ」と回答した項目について、予定の改善時期をお知らせください。',
         measures: {
          tls: 'TLS1.2以上バージョン対応',
          phone_security: 'モバイルアプリの安全性確保',
          use_pay_tool: '決済機能を備えたアプリケーションの利用',
          import_emv3d: 'EMV3D認証の導入',
          set_strong_pwd: '強固なパスワード設定',
          access_permission: '権限設定',
          check_access_log: 'アクセスログの確認'
        },
      
       
        improvementLabel: '予定改善時期'
      },

      // 非系统对策部分
      section4: {
        title: '(4) カード情報管理状況（非システム対策）',
        note: '※3～4項で「いいえ」と回答した項目について、予定の改善時期をお知らせください。',
        nonSystemMeasures: {
          set_employee_rule: '従業員規則の設定',
          scty_personal_info: '個人情報の機密性確保',
          set_customer_info: '顧客情報管理の設定',
          set_card_info_approval: 'カード情報承認の設定'
        },
        improvementLabel: '予定改善時期'
      },

      // 其他部分
      section5: {
        title: '(5) その他（自由記入）',
        placeholder: 'その他のご意見・ご要望がございましたら、こちらにご記入ください。'
      },
      table: {
        header1: '内容',
        header2: '回答欄',
        header3: '改善予定時期'
      },
      confirmButton: '内容を送信して確認する',
      yes: 'はい',
      no: 'いいえ',

      // 感谢语
    thankYou: 'ご協力誠にありがとうございました。',
    tip: {
        add: 'クレジットカード決済を選択されましたので、カード情報セキュリティ対策アンケートへのご回答をお願いいたします。',
        view: 'カード情報セキュリティ対策アンケートは既にご提出いただいております。'
      },
      addButton: 'アンケート回答',
      viewButton: 'アンケートを閲覧',
      submitSuccessed: 'アンケートを正常に送信しました',
      updateSuccessed: 'アンケートを正常に更新しました',
            qatips:'アンケートを作成してから送信してください',

     submitSuccess: {
        title: '送信完了',
        thankYou: 'ご協力誠にありがとうございました。',

      }

    }
  }
}






